import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import {
  CreateMixtureGroupExtras,
  isMixtureGroupWithCreatedMixture,
  MixtureGroupMetadata,
} from 'notebook/integrations/registry/MixtureGroupConstants';
import makeSimpleGroupActionFunction from 'notebook/notes/groups/action-functions/makeSimpleGroupActionFunction';
import {getMixtureGroupAdapter} from 'notebook/notes/groups/NoteLinkedGroupAdapters';
import legacyRunModal from 'ui-library/legacyRunModal';
import AddToWorklistModal from 'worklists/AddToWorklistModal';
import {WorklistType} from 'worklists/WorklistConstants';

const addMixtureGroupToWorklistActionFunction = makeSimpleGroupActionFunction<
  MixtureGroupMetadata,
  CreateMixtureGroupExtras
>({
  label: 'Add mixture to worklist',
  icon: 'worklist-add',
  onInvoke: ({noteLinkedGroup}) => {
    assert(
      isMixtureGroupWithCreatedMixture(noteLinkedGroup),
      'Cannot add to worklist when mixture id is missing'
    );
    const mixtureId = getMixtureGroupAdapter().getMixtureId(noteLinkedGroup)!;
    legacyRunModal(AddToWorklistModal, {
      ids: [mixtureId],
      worklistType: WorklistType.BIOENTITY,
      refreshOptions: {refreshRecentWorklists: true},
    });
  },
  getTooltip: ({noteLinkedGroup}) =>
    isMixtureGroupWithCreatedMixture(noteLinkedGroup) ? null : 'Register the mixture to add to worklist',
  getDisabled: ({noteLinkedGroup}) => !isMixtureGroupWithCreatedMixture(noteLinkedGroup),
  getHidden: () => !BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS,
});

export default addMixtureGroupToWorklistActionFunction;
